import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;
const S = {};

S.AuthForm = styled.form`
  label: AuthForm;
`;

S.AuthForm.InputsContainer = styled.div`
  label: InputsContainer;

  margin-bottom: ${({ isCreateAccount }) =>
    isCreateAccount ? '1.5rem' : '2rem'};

  @media (${widthSmall}) {
    margin-bottom: 2rem;
  }
`;

S.AuthForm.SubmitInput = styled.input`
  visibility: hidden;
  position: absolute;
`;

S.AuthForm.Title = styled.h1`
  label: Title;

  margin-bottom: 1.5rem;
`;

S.AuthForm.OptInCheckboxContainer = styled.div`
  label: OptInCheckboxContainer;

  margin-bottom: 1rem;

  @media (${widthSmall}) {
    margin-bottom: 1.5rem;
  }
`;

export default S;
